import './assets/style/main.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import './global.scss';

import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router';

import { PulseSVG } from './components/utils/svgs';
import { pageurl } from './constants/pageurl';
import { useBrowserCloseLogout } from './hooks/useBrowserCloseLogout';
import AuthRoute from './routes/auth-route';
import NotSupporterRoute from './routes/not-supporter-route';
import PartyAgentRoute from './routes/party-agent-route';

const OverviewPage = React.lazy(async () => await import('./components/pages/overview'));
const ReconciliationPage = React.lazy(async () => await import('./components/pages/reconciliation/ReconciliationPage'));
const Settings = React.lazy(async () => await import('./components/pages/settings'));
const SettingsProfile = React.lazy(async () => await import('./components/pages/settings/profile'));
const SettingsBankDetails = React.lazy(async () => await import('./components/pages/settings/bank-details'));
const SettingsGovernmentID = React.lazy(async () => await import('./components/pages/settings/government-id'));
const RequestAccess = React.lazy(async () => await import('./components/pages/request-access'));
const VerifyOTP = React.lazy(async () => await import('./components/pages/auth/verify-otp'));
const LoginPage = React.lazy(async () => await import('./components/pages/auth/login'));
const OnboardingPage = React.lazy(async () => await import('./components/pages/onboarding/Onboarding'));
const Page404 = React.lazy(async () => await import('./components/pages/page404'));
const AdminRoute = React.lazy(async () => await import('./routes/admin-route'));

const App = () => {
	// End the session when the browser is closed (refresh stays signed in).
	useBrowserCloseLogout();

	return (
		<Router basename={process.env.PUBLIC_URL}>
			<Suspense
				fallback={
					<div
						style={{ width: '100%', height: '100vh' }}
						className='f-column text-center align-items-center'
					>
						<PulseSVG />
					</div>
				}
			>
				<Routes>
					<Route
						path='/dashboard'
						element={<AdminRoute />}
					>
						<Route
							path={pageurl.OVERVIEW}
							element={<OverviewPage />}
						/>
						<Route
							path={pageurl.RESULTANALYTICS}
							element={
								<PartyAgentRoute>
									<ReconciliationPage />
								</PartyAgentRoute>
							}
						/>
						<Route
							path={pageurl.SETTINGS}
							element={
								<NotSupporterRoute>
									<Settings />
								</NotSupporterRoute>
							}
						/>
						<Route
							path={pageurl.SETTINGSPROFILE}
							element={
								<NotSupporterRoute>
									<SettingsProfile />
								</NotSupporterRoute>
							}
						/>
						<Route
							path={pageurl.SETTINGSBANKDETAILS}
							element={
								<NotSupporterRoute>
									<SettingsBankDetails />
								</NotSupporterRoute>
							}
						/>
						<Route
							path={pageurl.SETTINGSGOVERNMENTID}
							element={
								<NotSupporterRoute>
									<SettingsGovernmentID />
								</NotSupporterRoute>
							}
						/>
					</Route>
					<Route
						path='/'
						element={<AuthRoute />}
					>
						<Route
							path={pageurl.LOGIN}
							element={<LoginPage />}
						/>
						<Route
							path={pageurl.VERIFYOTP}
							element={<VerifyOTP />}
						/>
						<Route
							path={pageurl.REQUESTACCESS}
							element={<RequestAccess />}
						/>
						<Route
							path={pageurl.ONBOARDING}
							element={<OnboardingPage applicantRole='agent' />}
						/>
						<Route
							path={pageurl.OBSERVER_ONBOARDING}
							element={<OnboardingPage applicantRole='observer' />}
						/>
					</Route>
					<Route
						path='*'
						element={<Page404 />}
					/>
				</Routes>
			</Suspense>
		</Router>
	);
};

export default App;
